// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"fa5d8fb699d766d55f51","418":"bbe89b7f346dea8607ae","661":"1490727a768c7234af09"}[chunkId] + ".bundle.js";
};